import { render, staticRenderFns } from "./MessageBroker.vue?vue&type=template&id=b1dc27bc&"
import script from "./MessageBroker.vue?vue&type=script&lang=js&"
export * from "./MessageBroker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports